import { useContext } from 'react'
import utility from 'src/utils/utility'
import AppInfoContext from 'src/provider/state-manager/appInfoProvider'
import { SettingsD1, SettingsD3, SettingsD2 } from 'src/app/dashboard/settings/designs'
import { Design } from 'src/model'

const Settings: React.FC = () => {
    const {info: {institutionData}} = useContext(AppInfoContext)

    return (
        <>
            {
                institutionData.design === Design.DESIGN_1 ?
                    <SettingsD1/>
                    : institutionData.design === Design.DESIGN_2 ?
                        <SettingsD2 />
                        : 
                            <SettingsD3 />
            }
        </>
    )
}

export default utility.routeData('settings', 'Settings', <Settings/>)